<div class="navigation-bar flex flex-between">
  <a routerLink="/" class="navigation-bar-logo flex">
    <img [src]="'img/' + page + '/logo.png'" alt="Logo" class="logo" />
  </a>

  <mat-toolbar class="navigation">
    <ng-container *ngFor="let item of visibleNavItems()">
      <a
        *ngIf="item.downloadPath"
        mat-button
        [href]="item.downloadPath"
        download
        (click)="$event.stopPropagation()"
      >
        {{ item.labelKey | translate }}
      </a>

      <button
        *ngIf="!item.downloadPath"
        mat-button
        type="button"
        (click)="handleNavigation(item)">
          {{ item.labelKey | translate }}
      </button>
    </ng-container>

    <span class="spacer"></span>
    <button
      class="navigation__button"
      mat-button
      type="button"
      (click)="toggleLanguage()"
    >
      <img
        *ngIf="currentLang() === languageEnum.HR"
        src="img/languages/Eng.svg"
        alt="English"
        class="flag-icon"
      />

      <img
        *ngIf="currentLang() === languageEnum.EN"
        src="img/languages/Cro.svg"
        alt="Hrvatski"
        class="flag-icon"
      />

      {{ currentLang() === languageEnum.HR ? 'ENG' : 'HRV' }}
    </button>
  </mat-toolbar>

  <div class="flex">
    <div class="navigation-actions-buttons-container" *ngIf="isLogged">
      <app-navigation-cart *ngIf="isLogged"></app-navigation-cart>
    </div>

    <div class="menu-btn" (click)="toggleNav()" [class.active]="isNavOpen">
      <span></span>
    </div>
  </div>

  <div class="navigation-actions-container" [class.active]="isNavOpen">
    <div class="navigation-actions" [ngClass]="{'navigation-actions-logged': isLogged}">
      <div class="navigation-actions-buttons">
        <ng-container *ngFor="let item of visibleNavItems()">
          <a
            *ngIf="item.downloadPath"
            class="btn btn-primary"
            [href]="item.downloadPath"
            download
            (click)="$event.stopPropagation()"
          >
            {{ item.labelKey | translate }}
          </a>

          <button
            *ngIf="!item.downloadPath"
            class="btn btn-primary"
            type="button"
            (click)="handleNavigation(item); isNavOpen = false"
          >
            {{ item.labelKey | translate }}
          </button>
        </ng-container>
      </div>

      <button
        class="navigation__button"
        mat-button
        type="button"
        (click)="toggleLanguage()"
      >
        <img
          *ngIf="currentLang() === languageEnum.HR"
          src="img/languages/Eng.svg"
          alt="English"
          class="flag-icon"
        />

        <img
          *ngIf="currentLang() === languageEnum.EN"
          src="img/languages/Cro.svg"
          alt="Hrvatski"
          class="flag-icon"
        />

        {{ currentLang() === languageEnum.HR ? 'ENG' : 'HRV' }}
      </button>
    </div>
  </div>
</div>

<app-login-popup *ngIf="!isLogged && isLoginModalOpen()"></app-login-popup>
<app-forgotten-password *ngIf="!isLogged && isForgottenPassModalOpen()"></app-forgotten-password>
<app-registration *ngIf="!isLogged && isRegistrationModalOpen()"></app-registration>
